import * as React from "react";
import { IBaseTextBoxEditorProps, BaseTextBoxEditor } from "./BaseTextBoxEditor";
import { INumberTextBoxSpecificProps, NumberTextBox } from "./NumberTextBox";

export interface INumberTextBoxEditorProps
    extends IBaseTextBoxEditorProps,
        INumberTextBoxSpecificProps,
        React.Props<NumberTextBoxEditor> {}

export class NumberTextBoxEditor extends BaseTextBoxEditor<INumberTextBoxEditorProps> {
    private _maxTextBoxLength = 20;

    constructor(props: INumberTextBoxEditorProps) {
        super(props);
    }

    protected getInput(): JSX.Element {
        return (
            <NumberTextBox
                {...(this.props as any)}
                id={this.state.inputGroupId}
                inputMode="numeric"
                maxLength={this.props.maxLength || this._maxTextBoxLength}
                onValidationResultChange={(isValid: boolean, errors: string[], showValidationMessages: boolean) =>
                    this.handleValidationResultChange(isValid, errors, showValidationMessages)
                }
                onBlur={(value) => this.onBlur(value)}
                ariaInvalidCanBeShown={this.state.typingFinished}
                ariaInvalidShouldBeShown={!this.state.isValidOutside}
            />
        );
    }

    private onBlur(value: number): void {
        if (this.props.onBlur) {
            this.props.onBlur(value);
        }

        this.setState({ typingFinished: true });
    }

    private handleValidationResultChange(isValid: boolean, errors: string[], showValidationMessages: boolean): void {
        this.onValidationResultChange(isValid, errors, showValidationMessages);

        if (this.props.onValidation) {
            this.props.onValidation(errors);
        }
    }
}
